import Image from 'next/image';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';

import styles from './FaceModal.module.scss';

const Error = () => {
  const { t } = useTranslation();

  return (
    <div
      className={styles.face_modal_wrap}
      itemScope
      itemType='https://schema.org/Error'
    >
      <Image
        src='/assets/error.png'
        layout='fixed'
        width={56}
        height={56}
        alt={t('esim:common.errorTitle')}
        title={t('esim:common.errorTitle')}
        loading='lazy'
      />
      <p
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: t('esim:recognitionInfo.error') }}
      ></p>
    </div>
  );
};

export default Error;
